import React from 'react';

const initContext = {
  dataForm: {
    data: null, key: '', message: '', formResponses: [],
    hiddenFields: [], disabledFields: {}, model: {}
  },
  formStatus: { steps: [], currentStep: 0, currentQuestion: 0, numberQuestionsStep: 0 },
  product: '',
  isClean:'',
  typePerson:'',
  productAuto:'',
  executeCoverage:'',
  coverageAdd:[],
  returnButton: false,
  attempts:0,
  price: '',
  model:'',
  modalities:[],
  vehicleMake:'',
  priceToShow: '',
  responseCotizacion: {},
  showFinalMessage: { visible: true, title: '', message: '', number: '', visibleError: false },
  showAlert: { messagge: '', type: '' },
  backgroundServiceResponse: {},
  folio: '',
  homePageData: {},
  showHomePage: true,
  modality: "",
  selectedPeriodicity: 12,
  responseRequest: { cotizacion: [], emision: [] },
  isSendForm: false,
  progressStep: [],
  loadingProcedure: { visible: false, message: '' },
  loadingComponent: { visible: true, active: false },
  sidebarData: [],
  activeKey: '',
  insureds: [],
  checked: false,
  isSideBarUpdate:false,
  isClassActive: {},
  isActive: {},
  policyNumber: "",
  totalCoverages:[],
  cleanAditionalCoverages: false,
  activeBackButton: false,
  setTotalCoverages: () => { },
  setTypePerson:()=>{ },
  setIsClean:()=>{},
  setAttempts:()=>{},
  setIsClassActive: () => { },
  setChecked: () => { },
  setActiveKey: () => { },
  setSidebarData: () => { },
  setLoadingComponent: () => { },
  setProduct: () => { },
  setDataForm: () => { },
  setFormStatus: () => { },
  setReturnButton: () => { },
  setIsSideBarUpdate:()=>{ },
  setPrice: () => { },
  setPriceToShow: () => { },
  setResponseCotizacion: () => { },
  setShowFinalMessage: () => { },
  setShowAlert: () => { },
  setBackgroundServiceResponse: () => { },
  setFolio: () => { },
  setSelectedPeriodicity: () => { },
  setHomePageData: () => { },
  setShowHomePage: () => { },
  setModality: () => { },
  setIsSendForm: () => { },
  setProgressStep: () => { },
  setResponsesRequest: () => { },
  setLoadingProcedure: () => { },
  setInsureds: () => { },
  setIsActive: () => { },
  setPolicyNumber: () => { },
  setModel:()=>{},
  setCoverageAdd:()=>{},
  setVehicleMake:()=>{},
  setModalities:()=>{},
  setProductAuto:()=>{},
  setExecuteCoverage:()=>{},
  setCleanAditionalCoverages:()=>{},
  setActiveBackButton: () => {}
};

const Context = React.createContext(initContext);

export const Provider = Context.Provider;

export default Context;
